<div ngbDropdown container="body">
	<i data-testid="SUBSYS2_PLANLIST_ACTION_VIEWCASE" class="material-icons action"
		[title]="labels().PLAN_ACTION_COMPONENT_VIEW" [class.disabled]="isViewDisabled" (click)="view()" (keypress)="view()"
		[ngbTooltip]="isViewDisabled ? labels().PLAN_ACTION_COMPONENT_VIEW_DISABLED : null" placement="top"
		tooltipClass="white-tooltip">visibility</i>
	<i data-testid="SUBSYS2_RECEIVEDLIST_ACTION_CLONE" class="material-icons action"
		[title]="labels().RECEIVED_ACTION_COMPONENT_CLONE" [class.disabled]="isReadonly" (click)="openCloneModal()"
		(keypress)="openCloneModal()">content_copy</i>
	<i data-testid="SUBSYS2_RECEIVEDLIST_ACTION_SEE" class="material-icons action"
		[title]="labels().RECEIVED_ACTION_COMPONENT_SEE_MORE" (click)="openDetailModal()"
		(keypress)="openDetailModal()">vertical_split</i>
	<i data-testid="SUBSYS2_RECEIVEDLIST_ACTION_DELETE" class="material-icons action"
		[title]="labels().RECEIVED_ACTION_COMPONENT_DELETE" [class.disabled]="isReadonly" (click)="openDeleteModal()"
		(keypress)="openDeleteModal()">delete_outline</i>
</div>